import moment from "./app_moment";

type ClientDateOfBirth = Date | { toDate?: unknown } | null | undefined;

const getClientAge = (clientDOB: ClientDateOfBirth): number | null => {
    const toDate =
        clientDOB && typeof clientDOB === "object" && "toDate" in clientDOB
            ? clientDOB.toDate
            : undefined;
    const convertedDate =
        typeof toDate === "function" ? toDate.call(clientDOB) : clientDOB;

    if (!(convertedDate instanceof Date) || convertedDate.getTime() > Date.now()) {
        return null;
    }

    const age = moment().diff(convertedDate, "years", false);
    return age >= 0 ? age : null;
};

const isClientMinor = (clientDOB: ClientDateOfBirth) => {
    const age = getClientAge(clientDOB);
    return age !== null && age < 18;
};

const isClientElderly = (clientDOB: ClientDateOfBirth) => {
    const age = getClientAge(clientDOB);
    return age !== null && age >= 65;
};

export { getClientAge, isClientMinor, isClientElderly };
